import {useState} from "react";
import {FiPlus} from "react-icons/fi";

import Button from "@/components/button/Button.tsx";
import {ButtonVariant} from "@/components/button/Button.types.ts";
import {useCurrentUserContext} from "@/components/context/hooks.ts";
import {Icon} from "@/components/icon/Icon.tsx";
import {EditTagModal} from "@/pages/tags/edit/EditTagModal.tsx";

export const TagsActionBar = ({variant}: {variant?: ButtonVariant} = {}) => {
  const {user} = useCurrentUserContext();
  const [showEdit, setShowEdit] = useState(false);

  if (!user?.has_write_access) {
    return null;
  }

  return (
    <>
      <Button size="large" variant={variant} onClick={() => setShowEdit(true)}>
        <Icon icon={FiPlus} /> Create Tag
      </Button>
      <EditTagModal show={showEdit} hide={() => setShowEdit(false)} />
    </>
  );
};
